import { linkToAssignmentPage } from "../../links";

export function linkToReassign(classId?: string, assignmentId?: string) {
  return `${linkToAssignmentPage(classId, assignmentId)}/reassign`;
}

export function linkToSelectSectionStats(
  classId?: string,
  assignmentId?: string
) {
  return `${linkToReassign(classId, assignmentId)}/section`;
}

export function linkToPickDueDate(classId?: string, assignmentId?: string) {
  return `${linkToReassign(classId, assignmentId)}/due`;
}
